import appLocaleData from 'react-intl/locale-data/de';
import deMessages from '../locales/de_DE.json';
import deMessagesVariant from '../variant/de_DE.json';

const DeLang = {
  messages: {
    ...deMessages,
    ...deMessagesVariant,
  },
  locale: 'de-DE',
  data: appLocaleData,
};
export default DeLang;
